const NOK_WHOLE = new Intl.NumberFormat("nb-NO", {
    style: "currency",
    currency: "NOK",
    maximumFractionDigits: 0,
});
const NOK = new Intl.NumberFormat("nb-NO", {
    style: "currency",
    currency: "NOK",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
const GRAMS = new Intl.NumberFormat("nb-NO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
});
export function formatNok(value, withDecimals = true) {
    return (withDecimals ? NOK : NOK_WHOLE).format(value);
}
export function formatGrams(value) {
    return `${GRAMS.format(value)} g`;
}
export function formatKarat(karat) {
    return karat == null ? "—" : `${karat}K`;
}
export function maskDocumentNumber(value) {
    const trimmed = value?.trim();
    if (!trimmed)
        return null;
    if (trimmed.length <= 4)
        return "*".repeat(trimmed.length);
    return `${"*".repeat(trimmed.length - 4)}${trimmed.slice(-4)}`;
}
const ID_METHOD_LABELS = {
    VIPPS: "Vipps Login",
    PASSPORT: "Pass",
    DRIVER_LICENSE: "Førerkort",
    NATIONAL_ID_CARD: "Nasjonalt ID-kort",
    OTHER: "Annet",
};
export function idMethodLabel(method) {
    return method ? ID_METHOD_LABELS[method] : "Ukjent metode";
}
/** Norwegian label for a return/booking payment status. */
export function paymentStatusLabel(status) {
    switch (status) {
        case "REQUIRED":
            return "Betaling kreves";
        case "PENDING":
            return "Venter på betaling";
        case "AUTHORIZED":
            return "Reservert";
        case "CAPTURED":
            return "Betalt";
        case "REFUNDED":
            return "Refundert";
        case "FAILED":
            return "Betaling feilet";
        case "CANCELLED":
            return "Avbrutt";
        default:
            return status ?? "—";
    }
}
/** Ant Design Tag colour for a return/booking payment status. */
export function paymentStatusTone(status) {
    switch (status) {
        case "PENDING":
        case "REQUIRED":
            return "orange";
        case "AUTHORIZED":
            return "blue";
        case "CAPTURED":
            return "green";
        case "FAILED":
            return "red";
        default:
            return "default";
    }
}
const STONE_HANDLING_MODE_LABELS = {
    NONE_OR_KEEP: "Ingen stener, perler eller ur skal fjernes",
    REMOVE_ALL: "Alle stener, perler og ur fjernes",
    REMOVE_ALL_GOLDSMITH: "Alle stener, ur og perler fjernes skånsomt av gullsmed",
    SPECIFIC: "Utvalgte gjenstander får skånsomt fjernet stener, ur eller perler",
};
export function stoneHandlingModeLabel(mode) {
    return STONE_HANDLING_MODE_LABELS[mode];
}
/**
 * Both delivery kinds carry these fields, so the parameter is the check-in's shape — the permissive
 * one — rather than the mail order's, where both are required.
 *
 * `null` means nothing was recorded, which a staff-created check-in never asks about. That is not
 * the same as "keep everything", and must not be labelled as if it were.
 */
export function resolveStoneHandlingMode(delivery) {
    const details = delivery.stoneHandlingDetails;
    if (details)
        return details.mode === "REMOVE_ALL" ? "REMOVE_ALL_GOLDSMITH" : details.mode;
    if (delivery.stoneHandling == null)
        return null;
    return delivery.stoneHandling === "KEEP_AS_IS" ? "NONE_OR_KEEP" : "REMOVE_ALL_GOLDSMITH";
}
/** An 11-digit Norwegian account as it is printed on a giro: `1234.56.78903`. Anything else as-is. */
export function formatBankAccount(value) {
    const digits = value.replace(/\D/g, "");
    return digits.length === 11
        ? `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6)}`
        : value;
}
const DATE_NB = new Intl.DateTimeFormat("nb-NO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Europe/Oslo",
});
const TIME_NB = new Intl.DateTimeFormat("nb-NO", {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
    timeZone: "Europe/Oslo",
});
/** A calendar date the Norwegian way, 29.09.2026, in the shop's own time zone. */
export function formatDateNb(ms) {
    return DATE_NB.format(new Date(ms));
}
/** The date above with the clock, 29.09.2026 14:05. */
export function formatDateTimeNb(ms) {
    return `${formatDateNb(ms)} ${TIME_NB.format(new Date(ms))}`;
}
